module.exports = __WEBPACK_EXTERNAL_MODULE_47__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/select/dist/mdc.select","commonjs2":"@material/select/dist/mdc.select","commonjs":"@material/select/dist/mdc.select","amd":"@material/select/dist/mdc.select","umd":"@material/select/dist/mdc.select"}
// module id = 47
// module chunks = 0